import { Trans, useTranslation } from '@ecomm/i18n'
import { PerDaySlash } from '../../A11yHelpers/PerDaySlash'
import { StandardMonitoringBusinessModal } from '../../MonitoringPlanModalV2/StandardMonitoringBusinessModal/StandardMonitoringBusinessModal'
import { StandardPlanBox } from '../StandardPlanBox'

export function StandardPlanBoxAndModal() {
  const { t } = useTranslation('maps')

  return (
    <StandardPlanBox>
      <Trans
        components={{
          modalLink: (
            <StandardMonitoringBusinessModal showCTA={true}>
              text
            </StandardMonitoringBusinessModal>
          ),
          per: <PerDaySlash />
        }}
      >
        {t('standard-plan-callout')}
      </Trans>
    </StandardPlanBox>
  )
}
